// Client-side tokenisation + scoring for the CIE IGCSE Question Helper pilot.
// Implements the bundle scoring_rules:
//   - tokenise answer_text into word tokens with character offsets
//   - punctuation-only tokens are excluded from the scored denominator
//   - each token's gold label comes from the segment whose char range covers it
//   - annotation accuracy = correct scored tokens / total scored tokens * 100
//   - coverage = labelled scored tokens / total scored tokens * 100
//   - mark judgement bands from |student_mark - actual_mark|

export function tokenize(text) {
  const tokens = [];
  const re = /\S+/g;
  let m;
  let index = 0;
  while ((m = re.exec(text)) !== null) {
    const raw = m[0];
    tokens.push({
      index: index++,
      text: raw,
      start: m.index,
      end: m.index + raw.length,
      scored: /[A-Za-z0-9]/.test(raw), // exclude punctuation-only tokens
    });
  }
  return tokens;
}

// Gold category for a token: the segment that fully contains the token range.
export function goldCategoryForToken(token, segments) {
  for (const s of segments) {
    if (token.start >= s.char_start && token.end <= s.char_end) {
      return s.category_code;
    }
  }
  // Fallback: segment containing the token midpoint
  const mid = Math.floor((token.start + token.end) / 2);
  for (const s of segments) {
    if (mid >= s.char_start && mid < s.char_end) return s.category_code;
  }
  return null;
}

// annotations: { [tokenIndex]: category_code }
export function scoreAnnotations(tokens, annotations, segments) {
  const scored = tokens.filter((t) => t.scored);
  let correct = 0;
  let labelled = 0;
  scored.forEach((t) => {
    const gold = goldCategoryForToken(t, segments);
    const sel = annotations[t.index] || null;
    if (sel) labelled += 1;
    if (sel && sel === gold) correct += 1;
  });
  const total = scored.length || 1;
  return {
    totalScoredTokens: scored.length,
    correctTokens: correct,
    labelledTokens: labelled,
    accuracy: Math.round((correct / total) * 100),
    coverage: Math.round((labelled / total) * 100),
  };
}

const BANDS = {
  exact: { score: 100, message: 'Exact examiner judgement' },
  one_away: { score: 75, message: 'One mark away' },
  two_away: { score: 40, message: 'Two marks away' },
  three_or_more_away: { score: 0, message: 'Review the mark scheme and level descriptors' },
};

export function judgeMark(studentMark, actualMark) {
  const diff = Math.abs(studentMark - actualMark);
  let band;
  if (diff === 0) band = 'exact';
  else if (diff === 1) band = 'one_away';
  else if (diff === 2) band = 'two_away';
  else band = 'three_or_more_away';
  return {
    difference: diff,
    band,
    score: BANDS[band].score,
    message: BANDS[band].message,
  };
}
